module.exports = __webpack_public_path__ + "static/media/search.1e71c5df.png";